import React from 'react'
import {AnimatePresence, motion} from 'motion/react'

import {Divider} from '@vio/atlas/Divider'

const variants = {
  hidden: {opacity: 0, scale: 0.95},
  visible: {opacity: 1, scale: 1}
}

interface AnimatedDividerProps {
  inView: boolean
}

export const AnimatedDivider = ({inView}: AnimatedDividerProps) => {
  return (
    <AnimatePresence>
      {!inView && (
        <motion.div
          initial="hidden"
          animate="visible"
          exit="hidden"
          variants={variants}
          transition={{duration: 0.5}}
        >
          <Divider />
        </motion.div>
      )}
    </AnimatePresence>
  )
}
